import { render } from "./InteractiveView.vue?vue&type=template&id=65d8228c"
import script from "./InteractiveView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InteractiveView.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__